export default __webpack_public_path__ + "static/media/uit-id.b24f5002.png";